/* ÁNIMUS · slider before/after + modales + acordeones cerrados en producto */
(function(){
  function initSlider(rng){
    var box=rng.parentElement;
    while(box && !box.querySelector('img[style*="clip-path"]')) box=box.parentElement;
    if(!box) return;
    var clip=box.querySelector('img[style*="clip-path"]'), handle=box.querySelector('[id$="Handle"]');
    function upd(){var v=Math.max(0,Math.min(100,+rng.value||0));clip.style.clipPath="polygon(0 0,"+v+"% 0,"+v+"% 100%,0 100%)";if(handle)handle.style.left=v+"%";}
    rng.addEventListener("input",upd);rng.addEventListener("change",upd);upd();
  }
  function boot(){
    document.querySelectorAll("input[type=range]").forEach(initSlider);
    document.querySelectorAll("[data-open-modal]").forEach(function(b){b.addEventListener("click",function(){var d=document.getElementById(b.getAttribute("data-open-modal"));if(d&&d.showModal)d.showModal();});});
    document.querySelectorAll("[data-close-modal]").forEach(function(b){b.addEventListener("click",function(){var d=b.closest("dialog");if(d)d.close();});});
    document.querySelectorAll("dialog").forEach(function(d){d.addEventListener("click",function(e){if(e.target===d)d.close();});});
    if(location.pathname.indexOf("/products/")>-1){ document.querySelectorAll("details[open]").forEach(function(d){d.removeAttribute("open");}); }
  }
  if(document.readyState!=="loading")boot();else document.addEventListener("DOMContentLoaded",boot);
})();